import React, { useState, useRef, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import PlayerPanel from "../../components/ledversus/PlayerPanel";

import LEDWrapperViewer from "../../components/layout/LEDWrapperViewer";
import DebugOverlay from "../../components/widgets/DebugOverlay";

//HOOKS
import useLEDVersusTop8 from "../../hooks/useLEDVersusTop8";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function LEDChampionViewer() {
   const variants = {
      enter: {
         opacity: 1,
         transition: {
            easing: "easeOut",
            duration: 1,
            staggerChildren: 0.08,
         },
      },
      exit: {
         duration: 0.5,
         opacity: 0,
      },
   };

   const lineVariants = {
      enter: {
         opacity: 1,
         transition: {
            easing: "easeOut",
         },
      },
      exit: {
         opacity: 0,
      },
   };

   // USE HOOK
   const [
      title,
      allPlayers,
      selectedPlayers,
      show,
      { getSelectedPlayers, showHide, subscribeLEDVersusTop8Viewer },
   ] = useLEDVersusTop8();

   const [champion, setChampion] = useState();

   useEffect(() => {
      subscribeLEDVersusTop8Viewer();
      getSelectedPlayers();
   }, []);

   useEffect(() => {
      getChampion();
   }, [selectedPlayers]);

   const getChampion = () => {
      const champion = _.find(selectedPlayers, function (player) {
         if (player.champion) {
            return true;
         }
      });

      setChampion(champion);
   };

   return (
      <LEDWrapperViewer>
         <AnimatePresence>
            {selectedPlayers && (
               <Stack
                  spacing={0}
                  direction='row'
                  alignItems='center'
                  sx={{
                     height: "100%",
                     width: "100%",
                  }}
               >
                  <Box
                     sx={{
                        position: "relative",
                        width: 435,
                        boxSizing: "border-box",
                        overflow: "hidden",
                     }}
                     key={"panel1"}
                  >
                     <Stack
                        alignItems='center'
                        spacing={6}
                        sx={{ width: "100%" }}
                     >
                        <img
                           src={SERVER_URL + "/images/ui/logo-800.png"}
                           width='60%'
                        />
                     </Stack>
                  </Box>

                  <Box
                     sx={{
                        position: "relative",
                        width: 435,
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textAlign: "center",
                     }}
                     key={"panel2"}
                     component={motion.div}
                  >
                     <Typography
                        variant='h3Viewer'
                        sx={{
                           textTransform: "uppercase",
                           textAlign: "center",
                           lineHeight: "1em",
                           fontSize: "4em",
                           width: "100%",
                           overflow: "hidden",
                        }}
                     >
                        CHAMPION
                     </Typography>
                  </Box>

                  <Box
                     sx={{
                        position: "relative",
                        width: 435,
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textAlign: "center",
                        pb: 90,
                     }}
                     key={"panel3"}
                     component={motion.div}
                  >
                     {selectedPlayers && champion && (
                        <Typography
                           variant='h3LEDViewer'
                           sx={{
                              textTransform: "uppercase",
                              textAlign: "center",
                              fontSize: "3em",
                              lineHeight: "1em",
                              width: "100%",
                              overflow: "hidden",
                           }}
                        >
                           {champion.FirstName}
                           <br />
                           {champion.LastName}
                        </Typography>
                     )}
                  </Box>

                  <Box
                     sx={{
                        position: "relative",
                        width: 435,
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textAlign: "center",
                     }}
                     key={"panel4"}
                     component={motion.div}
                  >
                     <Typography
                        variant='h3Viewer'
                        sx={{
                           textTransform: "uppercase",
                           textAlign: "center",
                           lineHeight: "1em",
                           fontSize: "4em",
                           width: "100%",
                           overflow: "hidden",
                        }}
                     >
                        CHAMPION
                     </Typography>
                  </Box>

                  <Box
                     sx={{
                        position: "relative",
                        width: 435,
                        boxSizing: "border-box",
                        overflow: "hidden",
                     }}
                     key={"panel5"}
                  >
                     <Stack
                        alignItems='center'
                        spacing={6}
                        sx={{ width: "100%" }}
                     >
                        <img
                           src={SERVER_URL + "/images/ui/logo-800.png"}
                           width='60%'
                        />
                     </Stack>
                  </Box>
               </Stack>
            )}
         </AnimatePresence>
      </LEDWrapperViewer>
   );
}
